import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { ApplicationState } from '..';
import { Application } from '../Console';
import * as ConsoleStore from '../../store/Console';
import './Shortcuts.scss';
import { getCompanyUrlListByType } from '../../ApiUtils/ApiUtils';
import { CompanyUrl } from '../../components/Management/CompanyUrlsForm';
import { UserProfileContext } from '../../components/Console/ConsoleLayout';

type ApplicationSubmenuProps = {
    application: Application;
    className?: string;
    buttonClassName?: string;
    buttonConfig?: { label: string; urlParam: string; type: string }[];
    hasUrlList?: boolean;
} & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

type ApplicationSubmenuState = {
    companyUrlList: CompanyUrl[],
    company: string,
}

class ApplicationSubmenu extends React.Component<ApplicationSubmenuProps, ApplicationSubmenuState> {
    static contextType = UserProfileContext;
    public constructor(props: ApplicationSubmenuProps) {
        super(props);
        this.state = {
            companyUrlList: [],
            company: ''
        };
    }

    componentDidMount() {
        getCompanyUrlListByType(this.context?.company, this.props.application.urlType ?? '').then((response) => {
            this.setState({
                companyUrlList: response.data.companyUrls,
                company: this.context?.company,
            });
        }).catch(err => console.error("Error fetching company URLs:", err));
    }

    private HandleClick = (param: string, type: string) => {
        if (type == "routing") {
            const app = this.props.application;
            app.launcher = param;
            this.props.consoleActions.launchApplication(app);
        } else if (this.props.application.launcher != null) {
            let targetUrl = this.props.application.launcher + param;
            if (type == "redirect") {
                window.open(targetUrl, "_blank");
            } else if (type == "embedded") {
                this.props.push(`/console/embedded-view?&url=${btoa(targetUrl)}`);
            } 
        }
    };

    public render() {
        return (
            <div className={this.props.className} style={{ display: "flex", flexWrap: "wrap" }}>
                {this.props.hasUrlList && (
                    <div className={this.props.className} style={{ display: "flex", flexWrap: "wrap" }}>
                        {this.state.companyUrlList?.map((companyUrl, index) => (
                            <button
                                key={index}
                                className={this.props.buttonClassName ?? "mx-1 btn btn-primary quickSightButtons"}
                                onClick={() => this.HandleClick(companyUrl.url, "redirect")}
                            >
                                {companyUrl.urlName}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationSubmenu);
